import PaymentGatewayTesterDispatcher from '../dispatcher/PaymentGatewayTesterDispatcher'
import PaymentGatewayTesterConstants from '../constants/PaymentGatewayTesterConstants'
import DateHelper from '../../DateHelper/DateHelper'

var objectAssign = require('object-assign');
var EventEmitter = require('events').EventEmitter.prototype;

var PaymentGatewayTesterStore = objectAssign({}, EventEmitter, {

  _state: {
    gateways: [],
    gatewayOptions: null,
    readOnly: false,
    property_id: 0,
  },

  _steps: [
    'credentials',
    'store_card',
    'authorize',
    'capture',
    'void',
    'unstore_card'
  ],

  /**
  * Event Listener, Event Emitter
  */

  emitChange: function () {
    this.emit(PaymentGatewayTesterConstants.CHANGE_EVENT);
    this._state.forceUpdate = false;
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.on(PaymentGatewayTesterConstants.CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener: function (callback) {
    this.removeListener(PaymentGatewayTesterConstants.CHANGE_EVENT, callback);
  },

  /*
  * Initializes the store merging the options
  *
  * @param {object} opts
  */
  init: function (opts) {
    objectAssign(this._state, opts);

    this.parseGatewayDates();
  },

  parseGatewayDates: function () {
    // parse dates
    if (this._state.gateways && this._state.gateways.length > 0) {
      for (var i = 0, ilen = this._state.gateways.length; i < ilen; i++) {
        var gateway = this._state.gateways[i];

        if (typeof gateway.tested_at === 'string') {
          gateway.tested_at = DateHelper.parseDateFromBackend(gateway.tested_at);
        }

        if (typeof gateway.tested_successfully_at === 'string') {
          gateway.tested_successfully_at = DateHelper.parseDateFromBackend(gateway.tested_successfully_at);
        }
      }
    }
  },

  alert: function (title, msg) {
    BootstrapDialog.show({
      title: title,
      message: msg,
      buttons: [{
        label: I18n.t('ok'),
        action: function (dialog) {
          dialog.close();
        }
      }]
    });
  },

  /*
  * Cancels a gateway (resets the form back to uninitialized)
  */
  cancelGateway: function () {
    this._state.gateways = []
    this.emitChange();
  },

  /**
  * Deletes a gateway
  */
  deleteGateway: function (id) {
    var self = this;
    //var gateway = this.getGateway(id);

    $('.paymentGatewayTester .loadingOverlay').fadeIn('fast');

    $.ajax({
        type: 'POST',
        url: '/superadmin/payment-gateways/delete',
        data: {id: id},
    }).done(function (data) {
      $('.paymentGatewayTester .loadingOverlay').fadeOut('fast', function () {
        if (data.success) {
          if (self._state.gateways && self._state.gateways.length > 0) {
            for (var i = 0, ilen = self._state.gateways.length; i < ilen; i++) {
              if (self._state.gateways[i].id == id) {
                self._state.gateways.splice(i, 1);
                self.parseGatewayDates();
                break;
              }
            }
          }
        } else {
          self.alert(I18n.t('error'), data.error);
        }
        window.parent.$(window.parent).trigger('paymentGatewayChange');
        self.emitChange();
      });
    });
  },

  /**
  * Finds and returns gateway by ID
  */
  getGateway: function (id) {
    if (this._state.gateways && this._state.gateways.length > 0) {
      for (var i = 0, ilen = this._state.gateways.length; i < ilen; i++) {
        var gateway = this._state.gateways[i];

        if (gateway.id == id) {
          return gateway;
        }
      }
    }
  },

  getPropertyId: function () {
    return this._state.property_id;
  },

  getGateways: function () {
    return this._state.gateways;
  },

  getGatewayOptions: function () {
    return this._state.gatewayOptions;
  },

  getDefaultPaymentGateway: function () {
    for (var i = 0, ilen = this._state.gateways.length; i < ilen; i++) {
      if (this._state.gateways[i].default) {
        return this._state.gateways[i];
      }
    }
  },

  getReadOnly: function () {
    return this._state.readOnly;
  },

  newGateway: function () {
    var self = this;

    $('.paymentGatewayTester .loadingOverlay').fadeIn('fast');

    $.ajax({
        type: 'POST',
        url: '/superadmin/payment-gateways/new',
    }).done(function (data) {
      $('.paymentGatewayTester .loadingOverlay').fadeOut('fast', function () {
        if (data.success) {
          self._state.gateways.unshift(data.success);
          self.parseGatewayDates();
        }
        window.parent.$(window.parent).trigger('paymentGatewayChange');
        self.emitChange();
      });
    });
  },

  setGateway: function (gateway) {
    if (this._state.gateways && this._state.gateways.length > 0) {
      for (var i = 0, ilen = this._state.gateways.length; i < ilen; i++) {
        if (this._state.gateways[i].id === gateway.id) {
          this._state.gateways[i] = gateway;
          break;
        }
      }
    }

    this.emitChange();
  },

  setGatewayDefault: function (id, is_default) {
    var self = this;

    $('.paymentGatewayTester .loadingOverlay').fadeIn('fast');

    $.ajax({
        type: 'POST',
        url: '/superadmin/payment-gateways/set-default',
        data: {id: id, is_default: is_default},
    }).done(function (data) {
      $('.paymentGatewayTester .loadingOverlay').fadeOut('fast', function () {
        // conso
        if (data.success) {
          self._state.gateways = [data.success];
          self.parseGatewayDates();
          parent.refresh_data(self.getDefaultPaymentGateway());
          //$(window.top).trigger('setDefaultPaymentGateway', [self.getDefaultPaymentGateway()]);
        }
        window.parent.$(window.parent).trigger('paymentGatewayChange');
        self.emitChange();
      });
    });
  },

  setGatewayLive: function (id, is_live) {
    var self = this;

    $('.paymentGatewayTester .loadingOverlay').fadeIn('fast');

    $.ajax({
        type: 'POST',
        url: '/superadmin/payment-gateways/set-live',
        data: {id: id, is_live: is_live},
    }).done(function (data) {
      $('.paymentGatewayTester .loadingOverlay').fadeOut('fast', function () {
        // conso
        if (data.success) {
          self._state.gateways = [data.success];
          self.parseGatewayDates();
          parent.refresh_data(self.getDefaultPaymentGateway());
          //$(window.top).trigger('setDefaultPaymentGateway', [self.getDefaultPaymentGateway()]);
        }
        window.parent.$(window.parent).trigger('paymentGatewayChange');
        self.emitChange();
      });
    });
  },

});

PaymentGatewayTesterStore.dispatchToken = PaymentGatewayTesterDispatcher.register(function (payload) {

  switch (payload.action) {

    case PaymentGatewayTesterConstants.CANCEL_GATEWAY:
      PaymentGatewayTesterStore.cancelGateway();
      break;

    case PaymentGatewayTesterConstants.DELETE_GATEWAY:
      PaymentGatewayTesterStore.deleteGateway(payload.id);
      break;

    case PaymentGatewayTesterConstants.INIT:
      PaymentGatewayTesterStore.init(payload.opts);
      PaymentGatewayTesterStore.emitChange();
      break;

    case PaymentGatewayTesterConstants.SET_GATEWAY:
      PaymentGatewayTesterStore.setGateway(payload.gateway);
      break;

    case PaymentGatewayTesterConstants.SET_GATEWAY_DEFAULT:
      PaymentGatewayTesterStore.setGatewayDefault(payload.id, payload.is_default);
      break;

    case PaymentGatewayTesterConstants.SET_GATEWAY_LIVE:
      PaymentGatewayTesterStore.setGatewayLive(payload.id, payload.is_live);
      break;

    case PaymentGatewayTesterConstants.NEW_GATEWAY:
      PaymentGatewayTesterStore.newGateway();
      break;

    default:
      // no op
  }

});

/* silence the EventEmitter */
PaymentGatewayTesterStore.setMaxListeners(0);

export default PaymentGatewayTesterStore
